module.exports = __webpack_public_path__ + "static/media/bubble-1.d6acf9ce.png";